import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IncorrectPermissions = _resolveComponent("IncorrectPermissions")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_ReportExporter = _resolveComponent("ReportExporter")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      (!_ctx.canView)
        ? (_openBlock(), _createBlock(_component_IncorrectPermissions, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.canView)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            flat: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                color: "secondary",
                extended: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: "/",
                    custom: ""
                  }, {
                    default: _withCtx(({navigate}) => [
                      _createVNode(_component_v_btn, {
                        onClick: navigate,
                        icon: "",
                        class: "text-white"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode("mdi-arrow-left-circle", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_toolbar_title, { class: "text-white pageHeader" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("Retention Rate Report", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, {
                class: "mx-auto",
                "max-width": "100%",
                style: {"margin-top":"-60px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => [
                          (_ctx.isLoading)
                            ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_v_form, {
                                key: 1,
                                onSubmit: _withModifiers(_ctx.getReportData, ["prevent"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { md: "3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_select, {
                                            modelValue: _ctx.searchDto.year,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchDto.year) = $event)),
                                            label: "Fiscal Year",
                                            items: _ctx.fiscalYears,
                                            "item-value": "year",
                                            "item-title": "text"
                                          }, null, 8, ["modelValue", "items"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { md: "3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_autocomplete, {
                                            modelValue: _ctx.searchDto.programId,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchDto.programId) = $event)),
                                            label: "Treatment Program",
                                            items: _ctx.userAttachedPrograms,
                                            "item-value": "treatmentProgramId",
                                            "item-title": "description",
                                            clearable: "",
                                            "closable-chips": ""
                                          }, null, 8, ["modelValue", "items"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { md: "3" }, {
                                        default: _withCtx(() => [
                                          _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                            color: "info",
                                            onClick: _ctx.getReportData,
                                            disabled: _ctx.isSearching || !_ctx.searchDto.year || !_ctx.searchDto.programId
                                          }, {
                                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                              _createTextVNode("Get Report Data", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["onClick", "disabled"])), [
                                            [_directive_ripple]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onSubmit"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.isSearching)
                    ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                    : _createCommentVNode("", true),
                  (!_ctx.isSearching && !_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_data_table, {
                            headers: _ctx.headers,
                            items: _ctx.reportData,
                            density: "compact",
                            class: "elevation-1",
                            "no-data-text": "No results found"
                          }, _createSlots({
                            "item.category": _withCtx(({ item }) => [
                              _createTextVNode(_toDisplayString(item.category) + " ", 1),
                              (item.description)
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    location: "bottom"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_icon, _mergeProps(props, { icon: "mdi-information-variant-circle-outline" }), null, 16)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(item.description), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, [
                            (_ctx.reportData.length <= 10)
                              ? {
                                  name: "bottom",
                                  fn: _withCtx(() => []),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["headers", "items"]),
                          (!_ctx.isSearching && _ctx.reportData.length > 0)
                            ? (_openBlock(), _createBlock(_component_ReportExporter, {
                                key: 0,
                                items: _ctx.reportData,
                                title: "Retention Rate Report",
                                filename: "RetentionRateReport",
                                headers: _ctx.headers
                              }, null, 8, ["items", "headers"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}